/*
 * @Descripttion: 合同管理
 * @Date: 2024-12-23 15:21:31
 */
import { route } from './src/router';

const name = 'contract-mgmt';

export { name, route };
